import { Component, Input } from '@angular/core';
import { ModalRef } from '@app/core/services/core-modal.service';
import { CorePopupListSelectorConfig } from '../core-popup-list-selector.component';

@Component({
  selector: 'core-popup-list-selector-modal',
  templateUrl: './core-popup-list-selector-modal.component.html',
  styleUrls: ['./core-popup-list-selector-modal.component.scss'],
  standalone: false,
})
export class CorePopupListSelectorModalComponent {
  @Input() modalRef?: ModalRef<any[]>;
  @Input() config: CorePopupListSelectorConfig = new CorePopupListSelectorConfig();
  @Input() internalValue: any[] = [];

  maxSelectedItemsOver = false;

  getLabelOfItem(item: any) {
    if (typeof this.config.selectedDisplayedField === 'function') {
      return this.config.selectedDisplayedField(item);
    } else if (typeof this.config.selectedDisplayedField === 'string' && this.config.selectedDisplayedField in item) {
      return item[this.config.selectedDisplayedField];
    }
    return 'N/D';
  }

  checkMaxItems() {
    this.maxSelectedItemsOver = !!this.config.maxItems && this.internalValue.length > this.config.maxItems;
  }

  onCancel() {
    this.modalRef?.close(undefined);
  }

  onSave(event?: any): void {
    const isValid = event?.validationGroup ? event.validationGroup.validate().isValid : true;
    if (isValid && !this.maxSelectedItemsOver) {
      this.modalRef?.close([...this.internalValue]);
    }
  }
}
